import React, { PureComponent } from 'react';

import { withRouter } from 'react-router';

import ClickOutside from 'react-onclickoutside';

import axios from 'axios';

import omit from 'lodash/omit';

import withIntl from '../../../shared/intl-hoc';

import * as Banner from './banners';

import './index.less';

class Popup extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			index: 0
		};
	}

	handleClickOutside() {
		const router = this.props.router;

		router.replace({
			query: omit(router.location.query, 'o')
		});
	}

	change(i) {
		this.setState((state) => ({ ...state, index: state.index + i }));
	}

	render() {
		const intl = this.props.intl;
		const data = this.props.data;
		const lang = intl.language === 'ru' ? 'ru' : 'en';

		const i = this.state.index;

		return (
			<div className='year-results-popup-wrapper'>
				{i !== 0 && (
					<button
						className='year-results-popup-button prev'
						onClick={() => this.change(-1)}
					>
						<div />
					</button>
				)}
				<div className='year-results-popup-main'>
					<Banner.Preview intl={intl} lang={lang} visible={i === 0} {...data} />
					<Banner.Leads intl={intl} lang={lang} visible={i === 1} {...data} />
					<Banner.Income intl={intl} lang={lang} visible={i === 2} {...data} />
					<Banner.Quids intl={intl} lang={lang} visible={i === 3} {...data} />
					<Banner.Growth intl={intl} lang={lang} visible={i === 4} {...data} />
					<Banner.Offers intl={intl} lang={lang} visible={i === 5} {...data} />
					<Banner.Offer intl={intl} lang={lang} visible={i === 6} {...data} />
					<Banner.Country intl={intl} lang={lang} visible={i === 7} {...data} />
					<Banner.Month intl={intl} lang={lang} visible={i === 8} {...data} />
					<Banner.Rank intl={intl} lang={lang} visible={i === 9} {...data} />
					<Banner.Manager intl={intl} lang={lang} visible={i === 10} {...data} />
					<Banner.Final intl={intl} lang={lang} visible={i === 11} {...data} />
				</div>
				{!data.leads ? (
					<div className='year-results-popup-loader' />
				) : (
					<button
						className={`year-results-popup-button ${data.leads.count && i !== 11 ? 'next' : 'close'}`}
						onClick={() => {
							if (!data.leads.count || i === 11) {
								this.handleClickOutside();
							} else {
								this.change(+1);
							}
						}}
					>
						<div />
					</button>
				)}
			</div>
		);
	}
}

const YearResultsPopup = withIntl(withRouter(ClickOutside(Popup)));

class YearResultsPopupWindow extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			data: {
				leads: null,
				month: null,
				offers: 0,
				income: 0,
				quids: 0,
				rank_id: 0,
				country: null,
				offer: null,
				manager: null
			}
		};
	}

	componentDidMount() {
		axios.get('v2/profile/year-results')
			.then((res) => {
				this.setState((state) => ({
					...state,
					data: {
						...state.data,
						...res.data
					}
				}));
			});
	}

	render() {
		return this.props.isShowed && (
			<div className='year-results-popup-window'>
				<YearResultsPopup data={this.state.data} />
			</div>
		);
	}
}

export default YearResultsPopupWindow;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/year-results-popup/index.js